import { Backdrop, CircularProgress } from '@mui/material';

interface Props {
    loading?: boolean;
    fetching?: boolean | undefined;
    zIndex?: number;
}
function BackdropComponent({ loading, fetching, zIndex }: Props) {
    return (
        <Backdrop
            sx={{
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                color: '#fff',
                zIndex: zIndex ? zIndex : (theme) => theme.zIndex.drawer + 1
            }}
            open={loading || !!fetching}
        >
            <CircularProgress color="primary" />
        </Backdrop>
    );
}

export default BackdropComponent;
